export const version = "wordlists/5.4.0";
//# sourceMappingURL=_version.js.map